export default __webpack_public_path__ + "static/media/artist3.53c0c279.png";